export const cartActionTypes ={
    TOGGLE_CART_HIDDEN: 'TOGGLE_CART_HIDDEN',
    ADD_ITEM : 'ADD_ITEM',
    REMOVE_ITEM : 'REMOVE_ITEM',
    CLEAR_ITEM_FROM_CART : 'CLEAR_ITEM_FROM_CART',
    SET_CARTITEMS : 'SET_CARTITEMS',
    CART_CHANGE_LOADING: 'CART_CHANGE_LOADING' ,
    CART_CHANGE_ERROR: 'CART_CHANGE_ERROR'
} 